const createOrUpdateICAStoreSDK = (storeData) => {
  window.ICAStoreSDK = {
    storeData: {
      storeId: storeData.storeId
    }
  }

  dispatchStoreDataUpdatedEvent()
}

const dispatchStoreDataUpdatedEvent = () => {
  const storeDataUpdatedEvent = document.createEvent('Event')
  storeDataUpdatedEvent.initEvent('storeDataUpdated', true, true)

  window.dispatchEvent(storeDataUpdatedEvent)
}

export default {
 createOrUpdateICAStoreSDK
}
